import _ from "lodash";

import { splitToSubCollections } from "../../helpers/Collections";
import { DynamicProperty } from "./DynamicProperty";

interface Group {
  key: string;
  caption: string;
}

export class DynamicPropertiesOrganizer {
  propertiesGrouped: PropertiesGrouped[];

  constructor(properties: DynamicProperty[]) {
    this.propertiesGrouped = [];

    const groups = _.uniqBy(
      properties.map((p) => p.metadata.group),
      (group) => {
        return group?.key;
      }
    );

    groups.forEach((group) => {
      const propertiesFilterByGroup = _.filter(properties, function (property) {
        return property.metadata.group?.key === group?.key;
      });
      const propertiesGrouped = new PropertiesGrouped(group, propertiesFilterByGroup);
      this.propertiesGrouped.push(propertiesGrouped);
    });
  }

  getGroupedProperties() {
    return this.propertiesGrouped;
  }
}

export class PropertiesGrouped {
  subSections = 3;
  caption: string | undefined;
  propertiesInColumns: PropertiesInColumn[];
  longTextProperties: DynamicProperty[];

  constructor(group: Group | undefined, properties: DynamicProperty[]) {
    this.propertiesInColumns = [];
    this.longTextProperties = [];
    this.caption = group?.caption;

    const propertiesDisplayedInSubsections = properties.filter((p) => !p.isText());
    const propertiesSliceIntoSubsections = splitToSubCollections(
      propertiesDisplayedInSubsections,
      Math.ceil(propertiesDisplayedInSubsections.length / this.subSections)
    );
    propertiesSliceIntoSubsections.forEach((propertiesSliceIntoSubsection) => {
      const propertiesInColumn = new PropertiesInColumn(propertiesSliceIntoSubsection);
      this.propertiesInColumns.push(propertiesInColumn);
    });
    const numberOfEmptyColumns = this.subSections - this.propertiesInColumns.length;
    for (var i = 0; i < numberOfEmptyColumns; i++) {
      this.propertiesInColumns.push(new PropertiesInColumn([]));
    }

    this.longTextProperties = properties.filter((p) => p.isText());
  }

  getPropertiesGroupedInColumns() {
    return this.propertiesInColumns;
  }

  getLongTextProperties() {
    return this.longTextProperties;
  }
}

export class PropertiesInColumn {
  properties: DynamicProperty[];

  constructor(propertiesInColumns: DynamicProperty[]) {
    this.properties = propertiesInColumns;
  }
}
